import { VIDEO_REEL_CONSTANTS } from "../../constants/VideoReelConstants";

/** A story is never a reel, even with a stale reel flag left on it. */
export const isReelPost = (post: {
  isStory?: boolean;
  isVideo?: boolean;
  videoPostType?: string | null;
}): boolean =>
  !post.isStory &&
  !!post.isVideo &&
  post.videoPostType === VIDEO_REEL_CONSTANTS.POST_TYPES.REEL;
